import { api } from '@/app/api'

export const getMyAnimals = async () => {
  try {
    const { data } = await api.get('/v1/animals')
    return data?.animals || []
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getPlaceById = async (id) => {
  try {
    const { data } = await api.get(`/v2/orders/${id}`)
    return data?.orders?.[0] || null
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getPopularProducts = async (size = 8) => {
  try {
    const { data } = await api.get('/v2/shop-products', { params: { size } })
    return data?.data || []
  } catch (error) {
    console.error(error)
    return []
  }
}
